import { useAppSelector, useAppTranslation } from 'app/hooks';
import { MORE_WAGERS_FIRST_HALF, MORE_WAGERS_SECOND_HALF } from 'consts/app';
import Typo from 'consts/typography';
import { GameResponseModel } from 'models';
import React, { Fragment, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { makeSelectGameOddsById } from 'redux/gameSlice';
import { platformStates } from 'redux/platformSlice';
import { validateOdd } from 'utils/betUtils';
import WagerItem from './common/WagerItem';

interface MorWaggerProps {
  category: string;
  game: GameResponseModel;
}

const SECOND_HALF_WAGGER = ['football', 'basketball', 'hockey'];

const MoreWagger: React.FunctionComponent<MorWaggerProps> = (props) => {
  const { game, category } = props;
  const [tab, setTab] = useState<number>(1);
  const t = useAppTranslation();
  const { isPhone, isTablet } = useAppSelector(platformStates);
  const [searchParams, setSearchParams] = useSearchParams();

  const selectGameOddsById = useMemo(() => makeSelectGameOddsById(game.id), [game.id]);
  const oddsByGameId = useSelector(selectGameOddsById);

  const propsTab = [
    {
      label: t('moreWagersFirstHalf.title'),
      key: 1,
      content: (
        <div className="wager-list__item props">
          <Fragment>
            {MORE_WAGERS_FIRST_HALF.map((firstHalf) => {
              const groupOdds = Object.values(oddsByGameId || {})
                .flat()
                .filter((odd) => firstHalf.markets.includes(odd.market) && validateOdd(odd));
              const sortedOdds = groupOdds.sort((a, b) => {
                const aPriority =
                  a.selection === game.homeTeam || a.selectionLine?.toLowerCase() === 'under'
                    ? 1
                    : -1;
                const bPriority =
                  b.selection === game.homeTeam || b.selectionLine?.toLowerCase() === 'under'
                    ? 1
                    : -1;
                return aPriority - bPriority;
              });

              return (
                <WagerItem
                  key={firstHalf.title}
                  odds={sortedOdds}
                  title={t(firstHalf.title)}
                  game={game}
                  // status={status}
                  type={
                    firstHalf.title === 'moreWagersFirstHalf.total' ? 'alternate' : 'first half'
                  }
                  category={category}
                />
              );
            })}
          </Fragment>
        </div>
      ),
    },
    {
      label: t('moreWagersSecondHalf.title'),
      key: 2,
      content: (
        <div className="wager-list__item props">
          <Fragment>
            {MORE_WAGERS_SECOND_HALF.map((firstHalf) => {
              const groupOdds = Object.values(oddsByGameId || {})
                .flat()
                .filter((odd) => firstHalf.markets.includes(odd.market) && validateOdd(odd));
              const sortedOdds = groupOdds.sort((a, b) => {
                const aPriority =
                  a.selection === game.homeTeam || a.selectionLine?.toLowerCase() === 'under'
                    ? 1
                    : -1;
                const bPriority =
                  b.selection === game.homeTeam || b.selectionLine?.toLowerCase() === 'under'
                    ? 1
                    : -1;
                return aPriority - bPriority;
              });

              return (
                <WagerItem
                  key={firstHalf.title}
                  odds={sortedOdds}
                  title={t(firstHalf.title)}
                  game={game}
                  // status={status}
                  type={
                    firstHalf.title === 'moreWagersSecondHalf.total' ? 'alternate' : 'first half'
                  }
                  category={category}
                />
              );
            })}
          </Fragment>
        </div>
      ),
    },
  ];

  const onChangeTab = (tabKey: number) => {
    setTab(tabKey);
  };

  return SECOND_HALF_WAGGER.includes(searchParams.get('category') as string) ? (
    <div className="wager-list">
      <div className="header-league">
        <div className="league-tab">
          {propsTab.map((prop) => (
            <div
              key={prop.key}
              className={`league-tab-item ${prop.key === tab ? 'active' : ''}`}
              onClick={() => onChangeTab(prop.key)}
            >
              <span
                className={`primary-text-color ${isPhone ? Typo.p7 : isTablet ? Typo.p5 : Typo.p3}`}
              >
                {prop.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      {propsTab.find((p) => p.key === tab)?.content}
    </div>
  ) : (
    <div>{propsTab[0].content}</div>
  );
};

export default MoreWagger;
